module.exports = __webpack_public_path__ + "img/headportrait.5fe901ff.png";